<template>
    <div>
        <router-view></router-view>
        <Feedback></Feedback>
    </div>
</template>
<script>
import Feedback from '../components/feedback.vue'
export default {
    components:{
        Feedback
    }
}
</script>